import { Endpoint } from './types'

export const clientEndpoints: Endpoint[] = [
    {
        id: 'loan-offer',
        method: 'POST',
        path: '/api/client/loan-offer',
        title: {
            pt: 'Solicitar Oferta de Empréstimo',
            en: 'Request Loan Offer'
        },
        description: {
            pt: 'Solicita uma oferta de empréstimo com termos calculados incluindo juros, parcelas e prazos.',
            en: 'Request a loan offer with calculated terms including interest, installments, and payment schedule.'
        },
        authentication: true,
        authType: {
            pt: 'Token JWT de Cliente',
            en: 'JWT Client Token'
        },
        requestBody: {
            description: {
                pt: 'Valor do empréstimo solicitado',
                en: 'Requested loan amount'
            },
            example: {
                amount: 1000
            }
        },
        response: {
            description: {
                pt: 'Detalhes da oferta de empréstimo com juros, parcelas e termos',
                en: 'Loan offer details with interest, installments, and terms'
            },
            example: {
                success: true,
                data: {
                    amount: 1000,
                    interest: 100,
                    totalAmount: 1100,
                    installments: 4,
                    installmentAmount: 275
                }
            }
        },
        codeExamples: {
            curl: `curl -X POST https://api.emprex.com.br/api/client/loan-offer \\
  -H "Authorization: Bearer YOUR_JWT_TOKEN" \\
  -H "Content-Type: application/json" \\
  -d '{"amount": 1000}'`,
            javascript: `const response = await fetch('https://api.emprex.com.br/api/client/loan-offer', {
  method: 'POST',
  headers: {
    'Authorization': 'Bearer YOUR_JWT_TOKEN',
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({ amount: 1000 })
})
const data = await response.json()`
        }
    },
    {
        id: 'personal-data',
        method: 'POST',
        path: '/api/client/personal-data',
        title: {
            pt: 'Enviar Dados Pessoais',
            en: 'Submit Personal Data'
        },
        description: {
            pt: 'Envia ou atualiza informações pessoais do usuário necessárias para o processo de empréstimo.',
            en: 'Submit or update user personal information required for the loan process.'
        },
        authentication: true,
        authType: {
            pt: 'Token JWT de Cliente',
            en: 'JWT Client Token'
        },
        requestBody: {
            description: {
                pt: 'Objeto contendo dados pessoais do usuário',
                en: 'User personal data object'
            },
            example: {
                name: 'João Silva',
                cpf: '12345678900',
                birthDate: '1990-01-01',
                phone: '+5511999999999',
                address: {
                    street: 'Rua Exemplo',
                    number: '123',
                    city: 'São Paulo',
                    state: 'SP',
                    zipCode: '01234-567'
                }
            }
        },
        response: {
            description: {
                pt: 'Confirmação do envio dos dados',
                en: 'Confirmation of data submission'
            },
            example: {
                success: true,
                message: 'Dados pessoais atualizados com sucesso'
            }
        },
        codeExamples: {
            curl: `curl -X POST https://api.emprex.com.br/api/client/personal-data \\
  -H "Authorization: Bearer YOUR_JWT_TOKEN" \\
  -H "Content-Type: application/json" \\
  -d '{"name": "João Silva", "cpf": "12345678900", ...}'`,
            javascript: `const response = await fetch('https://api.emprex.com.br/api/client/personal-data', {
  method: 'POST',
  headers: {
    'Authorization': 'Bearer YOUR_JWT_TOKEN',
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({ name: 'João Silva', cpf: '12345678900', ... })
})`
        }
    },
    {
        id: 'get-transaction-id',
        method: 'POST',
        path: '/api/client/get-transaction-id',
        title: {
            pt: 'Obter ID de Transação KYC',
            en: 'Get KYC Transaction ID'
        },
        description: {
            pt: 'Recupera o ID de transação do módulo de KYC para validação biométrica e processo de verificação de identidade.',
            en: 'Retrieve KYC module transaction ID for biometric validation and identity verification process.'
        },
        authentication: true,
        authType: {
            pt: 'Token JWT de Cliente',
            en: 'JWT Client Token'
        },
        response: {
            description: {
                pt: 'ID de transação para processo de KYC',
                en: 'Transaction ID for KYC process'
            },
            example: {
                success: true,
                transactionId: 'abc123-def456-ghi789'
            }
        },
        codeExamples: {
            curl: `curl -X POST https://api.emprex.com.br/api/client/get-transaction-id \\
  -H "Authorization: Bearer YOUR_JWT_TOKEN"`,
            javascript: `const response = await fetch('https://api.emprex.com.br/api/client/get-transaction-id', {
  method: 'POST',
  headers: {
    'Authorization': 'Bearer YOUR_JWT_TOKEN'
  }
})`
        }
    },
    {
        id: 'sign-loan',
        method: 'POST',
        path: '/api/client/sign-loan',
        title: {
            pt: 'Assinar Empréstimo',
            en: 'Sign Loan'
        },
        description: {
            pt: 'Assina e finaliza a solicitação de empréstimo com aceite dos termos e condições.',
            en: 'Sign and finalize loan application with acceptance of terms and conditions.'
        },
        authentication: true,
        authType: {
            pt: 'Token JWT de Cliente',
            en: 'JWT Client Token'
        },
        requestBody: {
            description: {
                pt: 'Assinatura do empréstimo e aceite dos termos',
                en: 'Loan signature and terms acceptance'
            },
            example: {
                loanId: 'loan-123',
                acceptTerms: true,
                signature: 'base64_signature_data'
            }
        },
        response: {
            description: {
                pt: 'Detalhes de confirmação do empréstimo',
                en: 'Loan confirmation details'
            },
            example: {
                success: true,
                loanId: 'loan-123',
                status: 'approved',
                message: 'Empréstimo assinado com sucesso'
            }
        },
        codeExamples: {
            curl: `curl -X POST https://api.emprex.com.br/api/client/sign-loan \\
  -H "Authorization: Bearer YOUR_JWT_TOKEN" \\
  -H "Content-Type: application/json" \\
  -d '{"loanId": "loan-123", "acceptTerms": true, "signature": "..."}'`,
            javascript: `const response = await fetch('https://api.emprex.com.br/api/client/sign-loan', {
  method: 'POST',
  headers: {
    'Authorization': 'Bearer YOUR_JWT_TOKEN',
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({ loanId: 'loan-123', acceptTerms: true, signature: '...' })
})`
        }
    },
    {
        id: 'contract-document',
        method: 'POST',
        path: '/api/client/contract-document',
        title: {
            pt: 'Obter Documento de Contrato (CCB)',
            en: 'Get Contract Document (CCB)'
        },
        description: {
            pt: 'Recupera o documento de contrato de empréstimo (CCB - Cédula de Crédito Bancário).',
            en: 'Retrieve loan contract document (CCB - Banking Credit Note).'
        },
        authentication: true,
        authType: {
            pt: 'Token JWT de Cliente',
            en: 'JWT Client Token'
        },
        response: {
            description: {
                pt: 'Detalhes do documento de contrato e URL de download',
                en: 'Contract document details and download URL'
            },
            example: {
                success: true,
                documentUrl: 'https://s3.amazonaws.com/documents/ccb-loan-123.pdf',
                expiresAt: '2025-10-03T12:00:00Z'
            }
        },
        codeExamples: {
            curl: `curl -X POST https://api.emprex.com.br/api/client/contract-document \\
  -H "Authorization: Bearer YOUR_JWT_TOKEN"`,
            javascript: `const response = await fetch('https://api.emprex.com.br/api/client/contract-document', {
  method: 'POST',
  headers: {
    'Authorization': 'Bearer YOUR_JWT_TOKEN'
  }
})`
        }
    },
    {
        id: 'contract',
        method: 'GET',
        path: '/api/client/contract',
        title: {
            pt: 'Obter Detalhes do Contrato',
            en: 'Get Contract Details'
        },
        description: {
            pt: 'Obtém informações detalhadas do contrato de empréstimo incluindo termos, valores e status.',
            en: 'Get detailed loan contract information including terms, amounts, and status.'
        },
        authentication: true,
        authType: {
            pt: 'Token JWT de Cliente',
            en: 'JWT Client Token'
        },
        response: {
            description: {
                pt: 'Detalhes completos do contrato incluindo termos, valores e status',
                en: 'Complete contract details including terms, amounts, and status'
            },
            example: {
                success: true,
                contract: {
                    loanId: 'loan-123',
                    amount: 1000,
                    totalAmount: 1100,
                    installments: 4,
                    status: 'active',
                    startDate: '2025-10-01',
                    endDate: '2026-01-01'
                }
            }
        },
        codeExamples: {
            curl: `curl -X GET https://api.emprex.com.br/api/client/contract \\
  -H "Authorization: Bearer YOUR_JWT_TOKEN"`,
            javascript: `const response = await fetch('https://api.emprex.com.br/api/client/contract', {
  method: 'GET',
  headers: {
    'Authorization': 'Bearer YOUR_JWT_TOKEN'
  }
})`
        }
    },
    {
        id: 'create-invoice',
        method: 'POST',
        path: '/api/client/create-invoice',
        title: {
            pt: 'Gerar Fatura de Pagamento',
            en: 'Generate Payment Invoice'
        },
        description: {
            pt: 'Gera uma fatura de pagamento para parcela do empréstimo via módulo de pagamento.',
            en: 'Generate payment invoice for loan installment via payment module.'
        },
        authentication: true,
        authType: {
            pt: 'Token JWT de Cliente',
            en: 'JWT Client Token'
        },
        requestBody: {
            description: {
                pt: 'Número da parcela e valor',
                en: 'Installment number and amount'
            },
            example: {
                installment: 1,
                amount: 275
            }
        },
        response: {
            description: {
                pt: 'Detalhes da fatura com URL de pagamento e código de barras',
                en: 'Invoice details with payment URL and barcode'
            },
            example: {
                success: true,
                invoice: {
                    id: 'inv-123',
                    url: 'https://payment.example.com/invoices/inv-123',
                    barcode: '34191.79001 01043.510047 91020.150008 1 84350000002000',
                    dueDate: '2025-11-01'
                }
            }
        },
        codeExamples: {
            curl: `curl -X POST https://api.emprex.com.br/api/client/create-invoice \\
  -H "Authorization: Bearer YOUR_JWT_TOKEN" \\
  -H "Content-Type: application/json" \\
  -d '{"installment": 1, "amount": 275}'`,
            javascript: `const response = await fetch('https://api.emprex.com.br/api/client/create-invoice', {
  method: 'POST',
  headers: {
    'Authorization': 'Bearer YOUR_JWT_TOKEN',
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({ installment: 1, amount: 275 })
})`
        }
    },
    {
        id: 'receipt',
        method: 'GET',
        path: '/api/client/receipt',
        title: {
            pt: 'Obter Recibo de Pagamento',
            en: 'Get Payment Receipt'
        },
        description: {
            pt: 'Recupera o recibo de pagamento do empréstimo.',
            en: 'Retrieve payment receipt for loan.'
        },
        authentication: true,
        authType: {
            pt: 'Token JWT de Cliente',
            en: 'JWT Client Token'
        },
        response: {
            description: {
                pt: 'Detalhes do recibo e URL de download',
                en: 'Receipt document details and download URL'
            },
            example: {
                success: true,
                receiptUrl: 'https://s3.amazonaws.com/receipts/receipt-loan-123.pdf',
                expiresAt: '2025-10-03T12:00:00Z'
            }
        },
        codeExamples: {
            curl: `curl -X GET https://api.emprex.com.br/api/client/receipt \\
  -H "Authorization: Bearer YOUR_JWT_TOKEN"`,
            javascript: `const response = await fetch('https://api.emprex.com.br/api/client/receipt', {
  method: 'GET',
  headers: {
    'Authorization': 'Bearer YOUR_JWT_TOKEN'
  }
})`
        }
    },
    {
        id: 'query-pix',
        method: 'POST',
        path: '/api/client/query-pix',
        title: {
            pt: 'Validar Chave PIX',
            en: 'Validate PIX Key'
        },
        description: {
            pt: 'Valida e consulta informações de chave PIX para desembolso do empréstimo.',
            en: 'Validate and query PIX key information for loan disbursement.'
        },
        authentication: true,
        authType: {
            pt: 'Token JWT de Cliente',
            en: 'JWT Client Token'
        },
        requestBody: {
            description: {
                pt: 'Chave PIX e tipo da chave',
                en: 'PIX key and key type'
            },
            example: {
                pixKey: '+5511999999999',
                pixKeyType: 'phone'
            }
        },
        response: {
            description: {
                pt: 'Resultado da validação da chave PIX e detalhes da conta',
                en: 'PIX key validation result and account details'
            },
            example: {
                success: true,
                pixData: {
                    name: 'João Silva',
                    cpf: '123.456.789-00',
                    bank: 'Banco Exemplo',
                    accountType: 'checking'
                }
            }
        },
        codeExamples: {
            curl: `curl -X POST https://api.emprex.com.br/api/client/query-pix \\
  -H "Authorization: Bearer YOUR_JWT_TOKEN" \\
  -H "Content-Type: application/json" \\
  -d '{"pixKey": "+5511999999999", "pixKeyType": "phone"}'`,
            javascript: `const response = await fetch('https://api.emprex.com.br/api/client/query-pix', {
  method: 'POST',
  headers: {
    'Authorization': 'Bearer YOUR_JWT_TOKEN',
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({ pixKey: '+5511999999999', pixKeyType: 'phone' })
})`
        }
    }
]
